import { useEffect } from 'react';
import type { Collection } from 'src/apis/api-utilities';
import type {
  FavouriteNetworkPointsParams,
  NetworkPoint,
} from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useFavouriteNetworkPointsMonolith(
  params: FavouriteNetworkPointsParams
) {
  const favouriteNetworkPoints = useAxios(
    (axios, baseConfig, params: FavouriteNetworkPointsParams) =>
      axios.request<Collection<NetworkPoint>>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/networkPoints/favorites/page`,
        method: 'GET',
        params,
      }),
    {
      neededOnPageLoad: true,
    }
  );

  useEffect(() => {
    favouriteNetworkPoints.execute(params);
    // oxlint-disable-next-line exhaustive-deps
  }, [params]);

  return favouriteNetworkPoints;
}

export type FavouriteNetworkPointsRequest = ReturnType<
  typeof useFavouriteNetworkPointsMonolith
>;
